import StudentListSection from './StudentListSection';
import { StudentListSectionProps, StudentListSectionValueProps } from './types';

export type { StudentListSectionProps, StudentListSectionValueProps };
export default StudentListSection;
